/**
 * useLanguage — доступ к текущему языку и его смене.
 *
 * Возвращает:
 *   language  — нормализованный код ("ru" | "en" | "ar");
 *   dir       — "ltr" | "rtl" (для языка);
 *   languages — список поддерживаемых языков (code/label/short/dir);
 *   setLanguage(code) — переключить язык (сохраняется в localStorage).
 */
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import {
    SUPPORTED_LANGUAGES,
    getLanguageDir,
    normalizeLanguage,
} from "../i18n/config";

export function useLanguage() {
    const { i18n } = useTranslation();
    const language = normalizeLanguage(i18n.resolvedLanguage || i18n.language);

    const setLanguage = useCallback(
        (code) => {
            const next = normalizeLanguage(code);
            const current = normalizeLanguage(i18n.resolvedLanguage || i18n.language);
            if (next !== current) {
                i18n.changeLanguage(next);
            }
        },
        [i18n],
    );

    return {
        language,
        dir: getLanguageDir(language),
        languages: SUPPORTED_LANGUAGES,
        setLanguage,
    };
}

export default useLanguage;
